( function( global, $ ) {
    "use strict";

    $('body').on('app.init', function(ev) {
        var $container = $(ev.container);

        var _lang = {
            min: 'min',
            mins: 'min',
            hr: 'h',
            hrs: 'h'
        };

        // Default
        $container.find('[timepicker-default]').timepicker({
            timeFormat: 'H:i',
            step: 15,
            lang: _lang
        });

        // Duration
        var $duration = $container.find('[timepicker-duration]');
        if ($duration.length) {
            $duration.timepicker({
                'showDuration': true,
                'minTime': $duration.attr('data-min'),
                'maxTime': $duration.attr('data-max'),
                lang: _lang
            })
        }

        // Interval
        var $interval = $container.find('[timepicker-interval]');
        if ($interval.length) {
            $interval.timepicker({
                timeFormat: 'H:i',
                step: 15,
                minTime: $interval.attr('data-min'),
                maxTime: $interval.attr('data-max'),
                lang: _lang
            })
        }
    });

}( window.groots, jQuery ));
